/* eslint-disable max-classes-per-file */
export type Method =
  | 'get'
  | 'GET'
  | 'head'
  | 'HEAD'
  | 'post'
  | 'POST'
  | 'delete'
  | 'DELETE'
  | 'put'
  | 'PUT'
  | 'connect'
  | 'CONNECT'
  | 'options'
  | 'OPTIONS'
  | 'trace'
  | 'TRACE'
  | 'patch'
  | 'PATCH';

export type ResponseType = 'arraybuffer' | 'blob' | 'json' | 'text' | 'stream';

export class RequestError extends Error {
  code?: string;

  config: RequestOptions;

  constructor(message: string, options: RequestOptions) {
    super(message);
    this.config = options;
  }
}

export class ResponseError<T = any> extends Error {
  code?: string;

  response?: RequestResponse<T>;

  config: RequestOptions;

  constructor(message: string, options: RequestOptions, response: RequestResponse<T>) {
    super(message);
    this.response = response;
    this.config = options;
    this.code = response.status.toString();
  }
}

export interface Headers {
  [index: string]: any;
}

export type RequestPromise<T = any> = Promise<RequestResponse<T>>;

export interface RequestXMLHttpRequest {
  responseURL: string;
}

export interface RequestResponse<T = any> {
  config: RequestOptions;
  data: T;
  status: number;
  statusText: string;
  headers: Headers;
  request: RequestXMLHttpRequest;
}

export interface RequestOptions extends RequestInit {
  // 适配器
  adapter?: <T = any>(options: RequestOptions, defaultAdapter: (opts: RequestOptions) => RequestPromise<T>) => RequestPromise<T>;
  url?: string;
  baseURL?: string;
  method?: Method;
  headers?: Headers;
  credentials?: RequestCredentials;
  mode?: RequestMode;
  data?: any;
  body?: any;
  //  定义允许的响应内容的最大尺寸，单位为字节
  maxContentLength?: number;
  // 最大重定向数 默认为20
  maxRedirects?: number;
  follow?: number;
  params?: any;
  paramsSerializer?: (params: { [index: string]: string | number }) => string;
  // 设置超时时间
  timeout?: number;
  // 超时自定义提示文案
  timeoutMessage?: string;
  responseType?: ResponseType;
  validateStatus?: (status: number) => boolean;
  size?: number;
  signal?: AbortSignal;
}

export type FetchImplementation = (input: FetchRequestInfo, init?: FetchRequestInit) => Promise<FetchResponse>;

export type FetchRequestInfo = any;

export interface FetchResponse {
  readonly status: number;
  readonly statusText: string;
  readonly url: string;
  readonly body: unknown | null;
  arrayBuffer(): Promise<unknown>;
  blob(): Promise<unknown>;
  readonly headers: FetchHeaders;
  json(): Promise<any>;
  text(): Promise<string>;
}

export interface FetchRequestInit {
  method?: string;
}

export interface FetchHeaders {
  append(name: string, value: string): void;
  delete(name: string): void;
  get(name: string): string | null;
  has(name: string): boolean;
  set(name: string, value: string): void;
  forEach(callbackfn: (value: string, key: string) => void, thisArg?: any): void;
}
